<template>
    <transition name="slide-fade">
        <div :class="alertClasses" style="display:flex;align-items:center;" role="alert" :id="id" v-show="show" @click="close">
            <i :class="alertIcons"></i>
            <div class="ml-3">
                <strong v-text="alertText"></strong> {{ body }}
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['id', 'alertData'],
        data() {
            return {
                body: '',
                level: 'success',
                show: false,
                long: false,
            }
        },
        created() {
            if (!this.$auth.check()) return
            
            if(this.alertData) {
                this.feedback(this.alertData);
            }
            // window.events.$on( 'feedback', data => this.feedback(data) );
        },

        computed: {
            alertClasses() {
                let classes = ['alert', 'alert-flash', 'alert-'+this.level, 'border-white'];
                return classes;
            },

            alertText() {
                if(this.level == 'success') return 'Success!';
                else if(this.level == 'danger') return 'Error.';
                else return null;
            },

            alertIcons() {
                if(this.level == "danger") {
                    return ['fa', 'fa-lg', 'fa-times-circle'];
                } else if (this.level == "success") {
                    return ['fa', 'fa-lg', 'fa-check-circle'];
                } else {
                    return ['fa', 'fa-lg', 'fa-info-circle'];
                }
            }
        },

        methods: {
            feedback(data) {
                if (data) {
                    this.body = data.message;
                    this.level = data.level;
                    this.long = data.long;
                    this.show = true;
                    this.hide();
                }
            },

            hide() {
                let time = this.long ? 10000 : 5000;
                let self = this
                setTimeout(function() {
                    self.show = false;
                }, time);

                setTimeout(function() {
                    self.$emit('closeFeedback');
                }, time + 1000);
            },

            close() {
                this.show = false;
                this.$emit('closeFeedback');
            }
        }
    };
</script>

<style lang="scss" scoped>

.alert-success{
    background: var(--success) !important;
    color: white !important;
}

.alert-danger{
    background: var(--danger) !important;
    color: white !important;
}

.alert-warning{
    background: #ff8c00 !important;
    color: white !important;
}

</style>
